import { transformDate } from 'lib/utils/common';
import { Project, ProjectResponse } from 'types/project';

export const transformProjectResponse = (project: ProjectResponse): Project => {
  const {
    projectId,
    name,
    updatedAt,
    createdAt: _createdAt,
    chatCount: _chatCount,
    files,
    instruction,
  } = project;
  const { date } = transformDate(updatedAt);

  return { id: projectId, name, date, files, instruction };
};
